import React from 'react';
import { ICON } from '../../config/icons';
import './Breadcrumb.scss';

interface BreadcrumbProps {
  iconHeader?: React.ReactNode;
  label?: string;
  targetPath?: string;
}

export const Breadcrumb = ({ iconHeader, label, targetPath }: BreadcrumbProps) => {
  return (
    <>
      <div className={`breadcrumb--container`}>
        {iconHeader && <div className="icon-header">{iconHeader}</div>}
        {label && targetPath && (
          <>
            <img src={ICON.UI.CHEVRON} alt="indicator arrow to go back to campus" width={15} />

            <div className="link">
              <a href={targetPath}>{label}</a>
            </div>
          </>
        )}
      </div>
    </>
  );
};
